import { createFileRoute } from "@tanstack/react-router";
import { PortalSignUpPageContent } from "@/components/portal/PortalSignUpPageContent";

export const Route = createFileRoute("/portal_/sign-up")({
  component: PortalSignUpPage,
});

function PortalSignUpPage() {
  return <PortalSignUpPageContent />;
}
